/**
 * FS-838 — a code's own entry in a code→words map, never one inherited from
 * Object.prototype. A code is data from the server, and `constructor`,
 * `toString` or `__proto__` would otherwise read as a function (or the
 * prototype) and either print as nonsense or throw where a string is used.
 */
export function own<V>(map: Readonly<Record<string, V>>, key: string | null | undefined): V | undefined {
  return typeof key === 'string' && Object.prototype.hasOwnProperty.call(map, key) ? map[key] : undefined;
}
